module.exports = __webpack_public_path__ + "static/media/bar-inset.76dcc804.png";